import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../environments/environment';
import {OrderItem} from "../models/order-item";
import {Language} from "../models/language";

export class General {

  static calculateOrderItemTotal(orderItem: OrderItem) {
    const totalItems  = orderItem.price * orderItem.quantity;
    let totalOptions  = 0;

    if (!orderItem.optionsSelected) return totalItems;

    orderItem.optionsSelected.forEach(optionList => {
      // optionList.forEach(option => totalOptions += +option.price);
    });
    return totalItems + totalOptions;
  }

  static calculateTotalAmount(order: any): number {
    if (!order.items) return 0;

    let total = 0;
    order.items.forEach((orderItem: OrderItem) => {
      total += this.calculateOrderItemTotal(orderItem);
    });

    return total;
  }

  static replaceUnderscorebyDot(parameter: string): string {
    return parameter.split('_').join('.');
  }

  static replaceDotByUnderscore(parameter: string): string {
    return parameter.split('.').join('_');
  }

  static replaceSpaceByUnderscore(text: string): string {
    text = text.trim().toLowerCase();
    return text.split(' ').join('_');
  }

  static initLanguage(language: Language) {
    language.currentLanguage = language.defaultLanguage =
      environment.LANGUAGE.defaultLanguage;
  }

  static initTranslate(language: Language, translate: TranslateService) {
    const currentLanguage = language.currentLanguage;
    const browserLanguage = translate.getBrowserLang();

    if (this.checkSupportedLanguages(language, currentLanguage)) {
      translate.use(currentLanguage);
      language.currentLanguage = currentLanguage;
    } else if (this.checkSupportedLanguages(language, browserLanguage)) {
      translate.use(browserLanguage);
      language.currentLanguage = browserLanguage;
    } else {
      translate.use(language.defaultLanguage);
    }
  }

  static checkSupportedLanguages(language: Language, lang: string) {
    return true;
  }

  static changeLanguage(changeLangEvent) {
    // const lang: Language = EatmaticStoreService.getLanguage();
    //
    // const langIconPath = lang.currentIconPath = EatmaticStoreService.getLanguageIconPath(
    //   lang,
    //   lang.currentLanguage
    // );
    //
    // lang.currentLanguage === 'pt'
    //   ? (lang.currentLanguage = 'en')
    //   : (lang.currentLanguage = 'pt');
    //
    // EatmaticStoreService.setLanguage(lang);
    // changeLangEvent.publish('changeLanguage', lang.currentLanguage);

    // return langIconPath;
  }

  static quantityArray(num: number) {
    return new Array(num);
  }

  static optimizeOptions(options) {
    let optionsArray: any[] = [];

    if (options) {
      options.forEach(optionList => {
        if (optionsArray.length === 0) {
          optionsArray.push({
            options: optionList,
            quantity: 1
          });
        } else {
          let hasOptions = false;
          optionsArray.forEach(arrayOptionsList => {
            if (
              JSON.stringify(arrayOptionsList.options) ===
              JSON.stringify(optionList)
            ) {
              arrayOptionsList.quantity++;
              hasOptions = true;
            }
          });
          if (!hasOptions) {
            optionsArray.push({
              options: optionList,
              quantity: 1
            });
          }
        }
      });
    } else {
      optionsArray = [];
    }

    return optionsArray;
  }
}
